import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AddChecklist from "./AddChecklist";
import EditChecklist from "./EditChecklist";
import { setChecklist } from "./redux/actions";
import fetchChecklistsAction from "./redux/actions/fetchChecklistsAction";
import { withTranslation } from "react-i18next";
import isValidIdentifier from "helpers/isValidIdentifier";

const emptyChecklist = { label: "", description: "", items: [{ label: "Item 1", type: "CHECKBOX" }] };

class ManageChecklist extends Component {

    async componentDidMount() {
        const { organisationId, dispatch, t } = this.props;
        await dispatch(fetchChecklistsAction(organisationId, t));
        this.syncChecklistFromProps();
    }

    componentDidUpdate(prevProps) {
        const prevHasChecklist = isValidIdentifier(prevProps?.selectedChecklist?.id);
        const nextHasChecklist = isValidIdentifier(this.props?.selectedChecklist?.id);
        const checklistChanged = prevProps?.selectedChecklist?.id !== this.props?.selectedChecklist?.id;

        if (prevHasChecklist !== nextHasChecklist || (nextHasChecklist && checklistChanged)) {
            this.syncChecklistFromProps();
        }
    }

    syncChecklistFromProps = () => {
        const { selectedChecklist, setChecklist } = this.props;
        const hasChecklist = isValidIdentifier(selectedChecklist?.id);

        if (hasChecklist) {
            setChecklist(selectedChecklist);
            return;
        }

        setChecklist(emptyChecklist);
    }

    render() {

        const {
            index,
            organisationId,
            setChecklist,
            setActive,
            loading,
            applyChecklist,
            selectedChecklist,
            style,
            readOnly,
        } = this.props;

        if (loading) return null;

        const hasChecklist = isValidIdentifier(selectedChecklist?.id);

        if (hasChecklist) {
            return (
                <EditChecklist
                    index={index}
                    setActive={setActive}
                    organisationId={organisationId}
                    applyChecklist={applyChecklist}
                    readOnly={readOnly}
                />
            );
        }

        return (
            <AddChecklist
                index={index}
                style={style}
                applyChecklist={applyChecklist}
                setActive={setActive}
                organisationId={organisationId}
                readOnly={readOnly}
            />
        );
    }
}

ManageChecklist.propTypes = {
    index: PropTypes.number.isRequired,
    organisationId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    checklist: PropTypes.object,
    style: PropTypes.object,
    currentState: PropTypes.number.isRequired,
    setActive: PropTypes.func.isRequired,
    selectedChecklist: PropTypes.object,
    fetchChecklists: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    setChecklist: PropTypes.func.isRequired,
    applyChecklist: PropTypes.func.isRequired, // from measureTask in measure, task in dossier
    readOnly: PropTypes.bool,
};

const mapStateToProps = (state) => {
    const { manageChecklists, organisation } = state;
    const { currentState, loading } = manageChecklists;
    return { currentState, organisationId: organisation.current.id, loading };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchChecklists: (organisationId, checklist, index) => {
            return dispatch(fetchChecklistsAction(organisationId, checklist, index));
        },
        setChecklist: (checklist) => {
            dispatch(setChecklist(checklist));
        },
        dispatch
    };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ManageChecklist));
